import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuroraBackground from '../components/AuroraBackground/AuroraBackground';
import AuroraNavbar from '../components/AuroraNavbar/AuroraNavbar';
import Footer from '../components/Footer';
import MetaHead from '../components/MetaHead';
import '../styles/pg-legal.css';

export default function PolitiqueConfidentialite() {
  const { t, i18n } = useTranslation('legal');
  const isFrench = i18n.language === 'fr';

  return (
    <>
      <MetaHead page="legal_privacy" />
      <AuroraBackground dim />
      <AuroraNavbar />

      <main className="pg-legal">
        <h1 className="pg-legal-h1">{t('privacy.title')}</h1>
        <p className="pg-legal-updated">{t('privacy.last_update')}</p>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_1_title')}</h2>
          <p>{t('privacy.section_1_body_company')}</p>
          <p>
            {t('privacy.section_1_contact_label')}{' '}
            <a href="mailto:contact@getrevyo.com" className="pg-legal-link">contact@getrevyo.com</a>
          </p>
          <p>
            {t('privacy.section_1_dpo_label')}{' '}
            <a href="mailto:contact@getrevyo.com" className="pg-legal-link">contact@getrevyo.com</a>.
          </p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_2_title')}</h2>

          <h3 className="pg-legal-h3">{t('privacy.section_2_resto_subtitle')}</h3>
          <ul>
            <li>{t('privacy.section_2_resto_item_1')}</li>
            <li>{t('privacy.section_2_resto_item_2')}</li>
            <li>{t('privacy.section_2_resto_item_3')}</li>
            <li>{t('privacy.section_2_resto_item_4')}</li>
            <li>{t('privacy.section_2_resto_item_5')}</li>
          </ul>
          <p><strong>{t('privacy.section_2_resto_finality_label')}</strong> {t('privacy.section_2_resto_finality')}</p>
          <p><strong>{t('privacy.section_2_resto_legal_label')}</strong> {t('privacy.section_2_resto_legal')}</p>

          <h3 className="pg-legal-h3">{t('privacy.section_2_client_subtitle')}</h3>
          <ul>
            <li>{t('privacy.section_2_client_item_1')}</li>
            <li>{t('privacy.section_2_client_item_2')}</li>
            <li>{t('privacy.section_2_client_item_3')}</li>
          </ul>
          <p><strong>{t('privacy.section_2_client_finality_label')}</strong> {t('privacy.section_2_client_finality')}</p>
          <p><strong>{t('privacy.section_2_client_legal_label')}</strong> {t('privacy.section_2_client_legal')}</p>

          <h3 className="pg-legal-h3">{t('privacy.section_2_tech_subtitle')}</h3>
          <ul>
            <li>{t('privacy.section_2_tech_item_1')}</li>
            <li>{t('privacy.section_2_tech_item_2')}</li>
            <li>{t('privacy.section_2_tech_item_3')}</li>
          </ul>
          <p><strong>{t('privacy.section_2_tech_finality_label')}</strong> {t('privacy.section_2_tech_finality')}</p>
          <p><strong>{t('privacy.section_2_tech_legal_label')}</strong> {t('privacy.section_2_tech_legal')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_3_title')}</h2>
          <ul>
            <li>{t('privacy.section_3_item_1')}</li>
            <li>{t('privacy.section_3_item_2')}</li>
            <li>{t('privacy.section_3_item_3')}</li>
            <li>{t('privacy.section_3_item_4')}</li>
          </ul>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_4_title')}</h2>
          <p>{t('privacy.section_4_intro')}</p>
          <div className="pg-legal-table-wrap">
            <table className="pg-legal-table">
              <thead>
                <tr>
                  <th>{t('privacy.section_4_th_subprocessor')}</th>
                  <th>{t('privacy.section_4_th_service')}</th>
                  <th>{t('privacy.section_4_th_location')}</th>
                  <th>{t('privacy.section_4_th_warranties')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Vercel Inc.</strong></td>
                  <td>{t('privacy.section_4_row1_service')}</td>
                  <td>{t('privacy.section_4_row1_location')}</td>
                  <td>{t('privacy.section_4_row1_warranties')}</td>
                </tr>
                <tr>
                  <td><strong>Railway Corp.</strong></td>
                  <td>{t('privacy.section_4_row2_service')}</td>
                  <td>{t('privacy.section_4_row2_location')}</td>
                  <td>{t('privacy.section_4_row2_warranties')}</td>
                </tr>
                <tr>
                  <td><strong>Brevo</strong> (ex-Sendinblue)</td>
                  <td>{t('privacy.section_4_row3_service')}</td>
                  <td>{t('privacy.section_4_row3_location')}</td>
                  <td>{t('privacy.section_4_row3_warranties')}</td>
                </tr>
                <tr>
                  <td><strong>Twilio Inc.</strong></td>
                  <td>{t('privacy.section_4_row4_service')}</td>
                  <td>{t('privacy.section_4_row4_location')}</td>
                  <td>{t('privacy.section_4_row4_warranties')}</td>
                </tr>
                <tr>
                  <td><strong>Stripe Inc.</strong></td>
                  <td>{t('privacy.section_4_row5_service')}</td>
                  <td>{t('privacy.section_4_row5_location')}</td>
                  <td>{t('privacy.section_4_row5_warranties')}</td>
                </tr>
                <tr>
                  <td><strong>Anthropic PBC</strong></td>
                  <td>{t('privacy.section_4_row6_service')}</td>
                  <td>{t('privacy.section_4_row6_location')}</td>
                  <td>{t('privacy.section_4_row6_warranties')}</td>
                </tr>
                <tr>
                  <td><strong>Google LLC</strong></td>
                  <td>{t('privacy.section_4_row7_service')}</td>
                  <td>{t('privacy.section_4_row7_location')}</td>
                  <td>{t('privacy.section_4_row7_warranties')}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="pg-legal-note">{t('privacy.section_4_note')}</div>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_5_title')}</h2>
          <p>{t('privacy.section_5_intro')}</p>
          <ul>
            <li>
              <strong>{t('privacy.section_5_right_access_label')}</strong> {t('privacy.section_5_right_access_body')}
            </li>
            <li>
              <strong>{t('privacy.section_5_right_rectif_label')}</strong> {t('privacy.section_5_right_rectif_body')}
            </li>
            <li>
              <strong>{t('privacy.section_5_right_erase_label')}</strong> {t('privacy.section_5_right_erase_body')}
            </li>
            <li>
              <strong>{t('privacy.section_5_right_porta_label')}</strong> {t('privacy.section_5_right_porta_body')}
            </li>
            <li>
              <strong>{t('privacy.section_5_right_oppo_label')}</strong> {t('privacy.section_5_right_oppo_body')}
            </li>
            <li>
              <strong>{t('privacy.section_5_right_claim_label')}</strong> {t('privacy.section_5_right_claim_body_part1')}{' '}
              <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="pg-legal-link">{t('privacy.section_5_right_claim_body_link')}</a>{' '}
              {t('privacy.section_5_right_claim_body_part2')}
            </li>
          </ul>
          <p>
            {t('privacy.section_5_exercise')}{' '}
            <a href="mailto:contact@getrevyo.com" className="pg-legal-link">contact@getrevyo.com</a>
          </p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_6_title')}</h2>
          <ul>
            <li>{t('privacy.section_6_item_1')}</li>
            <li>{t('privacy.section_6_item_2')}</li>
            <li>{t('privacy.section_6_item_3')}</li>
            <li>{t('privacy.section_6_item_4')}</li>
            <li>{t('privacy.section_6_item_5')}</li>
            <li>{t('privacy.section_6_item_6')}</li>
            <li>{t('privacy.section_6_item_7')}</li>
          </ul>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_7_title')}</h2>
          <p>{t('privacy.section_7_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_8_title')}</h2>
          <p>{t('privacy.section_8_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('privacy.section_9_title')}</h2>
          <p>
            <a href="mailto:contact@getrevyo.com" className="pg-legal-link">contact@getrevyo.com</a>
            &nbsp;{t('privacy.section_9_body_address')}
          </p>
          <p>
            {t('privacy.section_9_see_also_part1')}{' '}
            <Link to="/mentions-legales" className="pg-legal-link">{t('privacy.section_9_mentions_link')}</Link>
            {' '}{t('privacy.section_9_see_also_part2')}{' '}
            <Link to="/cgv" className="pg-legal-link">{t('privacy.section_9_cgv_link')}</Link>.
          </p>
        </div>

        {!isFrench && (
          <div className="pg-legal-disclaimer">{t('common.disclaimer_translation')}</div>
        )}
      </main>

      <Footer />
    </>
  );
}
